import { createSlice } from '@reduxjs/toolkit';
import { Organization } from 'global/types';

interface OrganizationState {
    initializing: boolean;
    organization: Organization;
};

const initialState: OrganizationState = {
    initializing: true,
    organization: {
        alias: null,
        urlSlug: null,
        name: null,
        logo: null,
        favicon: null,
        themeColor: null,
        backgroundColor: null,
    },
};

export const organizationSlice = createSlice({
    name: 'organization',
    initialState, 
    reducers: {
        setOrganization: (state, action) => {
            state.initializing = false;
            state.organization = action.payload;
        },
        organizationNotFound: (state) => {
            state.initializing = false;
            state.organization = initialState.organization;
        }
    }
});

export const { setOrganization, organizationNotFound } = organizationSlice.actions;

export default organizationSlice.reducer;